import { useSelector }  from 'react-redux'
import LocationEditForm from '../../components/Locations/LocationEditForm'
import MainLayout       from '../../layouts/MainLayout'

export default function LocationsEdit(): JSX.Element {
  const currentUser: any = useSelector( ( state: any ): any => state.currentUser.user )

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { currentUser?.admin && <LocationEditForm /> }

          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
